import { CourseIntakeBatch } from "@/interfaces/courseIntakeBatch.interface";
import getMonthName from "./getMonthName";

export const getFormattedIntake = (
  intake: CourseIntakeBatch,
  cohort?: string
): string => {
  if (!intake) return "";
  return `${intake.course?.course_code || ""} 
  ${getMonthName(intake.month).toUpperCase()} 
  ${intake.year} 
   ${cohort ?? intake.cohort}`;
};
